import React from 'react'
import { animated, useTransition } from 'react-spring';
import {Image, Transformation} from 'cloudinary-react';

const SliderComponent = (props) => {

    const [count, setCount] =React.useState(0);
    const [reverse, setReverse] = React.useState(false);

    const prevSlide = () => {
        let prevSlide = count - 1 < 0 ? props.imagesList.length - 1 : count - 1;
        setCount(prevSlide);
        setReverse(true);
      };
    
      const nextSlide = () => {

          console.log('fjksdfjk')
        let nextSlide = count + 1 < props.imagesList.length ? count + 1 : 0;
        setCount(nextSlide);
        setReverse(false);
      };

    const imgList = props.imagesList || [];
    //   const pages = imgList.map((item, i)=> 
    //       ({style}) => <animated.div style={{...style}}>
    //           <Image
    //             publicId={item.url}
    //             cloud_name="jagannath" 
    //             style={{width: "300px", height:"300px"}}
    //             className="avatar-view mr-3">
    //                 <Transformation 
    //                     height="100" 
    //                     width="100" 
    //                     crop="fill" 
    //                     // effect="sepia" 
    //                     radius="2" />
    //         </Image>
    //       </animated.div>
    //   );

      const transitions = useTransition([count], item => item, {
        from: { opacity: 0, transform: reverse ? 'translate3d(100%,0,0)' : 'translate3d(-50%,0,0)' },
        enter: { opacity: 1, transform: 'translate3d(0,0,0)' },
        leave: { opacity: 0, transform: reverse ? 'translate3d(-50%,0,0)' : 'translate3d(100%,0,0)' },
        // from: {
        //   opacity: 0,
        //   marginLeft: reverse ? 200 : 0,
        //   position: 'absolute',
        // //   boxShadow: '0px 100px 20px 0px rgba(0,0,0,0.4)'
        // },
        // enter: { opacity: 1, marginLeft: 100 },
        // leave: { opacity: 0, marginLeft: reverse ? 0 : 200 }
      });

    return (
        <div>
            <button onClick={nextSlide}>next</button>
                <button onClick={prevSlide}>prev</button>
                <div className="simple-trans-main" >
                    {transitions.map(({ item, props, key }) =>(
                        // const Page = pages[item]
                        // return <Page key={key} style={props} />

                        <animated.div key={key} style={props}>
                            <img style={{marginLeft: "30px"}} src={imgList[item].url} width="300px" height="300px" alt="carousel-img" />
                        </animated.div>
                    )
                )}

                    

                </div>
        </div>
    )
}


export default SliderComponent